import React from "react";

import { Box, Typography } from "@mui/material";

/** A single label/value pair used in the review screens. */
export const SummaryRow: React.FC<{ label: string; value?: string | number | null | React.ReactNode }> = ({
  label,
  value
}) => {
  if (value == null || value === "") return null;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.5,
        borderBottom: "1px solid",
        borderColor: "divider"
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600}>
        {value}
      </Typography>
    </Box>
  );
};

export const SummarySection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography
      variant="overline"
      sx={{ color: "text.secondary", fontWeight: 700, letterSpacing: 1.2, display: "block", mb: 1 }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);
